/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForMicrosoftTeams extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForMicrosoftTeams");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForMicrosoftTeams.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForMicrosoftTeams>): ServiceAccountNativeDetailsForMicrosoftTeams {
        let obj = Object.assign(new ServiceAccountNativeDetailsForMicrosoftTeams(), model);
        ServiceAccountNativeDetailsForMicrosoftTeams.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForMicrosoftTeams>): ServiceAccountNativeDetailsForMicrosoftTeams {
        if (!model) return null;
        return ServiceAccountNativeDetailsForMicrosoftTeams.newInstance(<ServiceAccountNativeDetailsForMicrosoftTeams> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForMicrosoftTeams) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForMicrosoftTeams.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForMicrosoftTeams): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForMicrosoftTeams.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Azure Cloud Type. This is a required field.
     */
    cloud_type: models.AzureCloudType;

}
